<template>
  <div class="flex flex-col gap-7 px-6">
    <div class="flex flex-col gap-2">
      <BaseText
        type="label"
        size="lg"
        class="text-text-loud"
      >
        Add the site you're tracking
      </BaseText>
      <BaseText
        type="body"
        size="md"
        class="text-text-normal max-w-3xl"
      >
        Spendback matches ad spend to revenue with a small snippet on your site. Add the domain and we'll generate it in the next step.
      </BaseText>
    </div>

    <div class="space-y-5 max-w-md">
      <BaseInputV3
        label="Name"
        placeholder="Enter your brand name"
        :input-value="form.propertyName"
        @update:inputValue="updateFormField('propertyName', $event)"
      />

      <div class="space-y-2">
        <BaseInputV3
          label="Site URL"
          placeholder="yourbrand.com"
          :input-value="form.siteUrl"
          @update:inputValue="updateFormField('siteUrl', $event)"
        />
        <div
          v-if="loadingDomains"
          class="h-6 w-full skeleton rounded-md max-w-xs"
        />
        <div
          v-else-if="detectedDomains?.length > 0"
          class="flex items-center gap-2"
        >
          <BaseText
            size="sm"
            class="text-text-normal"
          >
            From your active ads
          </BaseText>
          <button
            v-for="domain in detectedDomains"
            :key="domain"
            class="p-1 px-2 rounded-md bg-background-normal group"
            @click="updateFormField('siteUrl', domain)"
          >
            <BaseText
              type="label"
              size="xs"
              class="text-text-muted group-hover:underline"
            >
              {{ domain }}
            </BaseText>
          </button>
        </div>
      </div>
    </div>

    <div class="flex items-start">
      <button
        class="black-btn-primary flex items-center gap-1 pl-2.5 pr-1.5 py-1.5 rounded-md"
        :disabled="submitting"
        @click="$emit('continue', form)"
      >
        <BaseText
          type="label"
          size="sm"
          class="text-white whitespace-nowrap"
        >
          Continue to {{ nextStepLabel || 'Next' }}
        </BaseText>
        <BaseLoadingSpinnerCircle
          v-if="submitting"
          class="text-white w-5 h-5"
          :duration="1"
        />
        <ChevronIcon
          v-else
          class-name="text-white transform -rotate-90"
          :width="20"
          :height="20"
        />
      </button>
    </div>
  </div>
</template>

<script>
import LensAPI from '../../../../api/lens/LensRequests'

// Icons
import ChevronIcon from '../../../globals/Icons/ChevronIcon.vue'

export default {
  name: 'SpendBackStepProperty',
  components: {
    ChevronIcon
  },
  props: {
    lensId: {
      type: String,
      required: true
    },
    lens: {
      type: Object,
      default: () => ({})
    },
    nextStepLabel: {
      type: String,
      default: null
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingDomains: false,

      detectedDomains: [],
      form: {
        propertyName: this.lens?.name || '',
        siteUrl: ''
      }
    }
  },
  async mounted () {
    await this.fetchAutofillDomains()
  },
  methods: {
    async fetchAutofillDomains () {
      this.loadingDomains = true
      try {
        const { data } = await LensAPI.SpendBack.getAutofillDomains(this.lensId)
        this.detectedDomains = data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingDomains = false
      }
    },
    updateFormField (field, value) {
      this.form[field] = value
    }
  }
}
</script>
